.chip {
  position: relative;
  display: flex;
  align-items: center;
  gap: var(--space-3);
  /* Share the row and shrink — never force the strip wider than the page */
  flex: 1 1 160px;
  min-width: 0;
  padding: var(--space-3) var(--space-4);
  background: var(--bg-card);
  border: 1px solid var(--border-subtle);
  border-radius: var(--radius-lg);
  cursor: pointer;
  overflow: hidden;
  text-align: left;
  scroll-snap-align: start;
  transition:
    transform var(--duration-fast) var(--ease-default),
    border-color var(--duration-fast) var(--ease-default),
    box-shadow var(--duration-fast) var(--ease-default),
    background var(--duration-fast) var(--ease-default);
}

/* Amber left-stripe — the ranked-card HUD accent. Fades in on hover, stays on
   when selected. Clipped to the radius by the chip's overflow:hidden. */
.chip::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 3px;
  pointer-events: none;
  z-index: 3;
  background: linear-gradient(
    180deg,
    transparent 0%,
    var(--accent-secondary) 20%,
    var(--accent-secondary) 80%,
    transparent 100%
  );
  opacity: 0;
  transition: opacity var(--duration-fast) var(--ease-default);
}

.chip:hover {
  transform: translateY(-2px);
  border-color: var(--border-default);
  box-shadow: 0 -8px 30px rgba(240, 180, 41, 0.12);
}

.chip:hover::before {
  opacity: 1;
}

.chip:focus-visible {
  outline: 2px solid var(--border-focus);
  outline-offset: 2px;
}

/* Brand tint, kept faint so ten of these in a row don't turn into a rainbow */
.wash {
  position: absolute;
  inset: 0;
  background: linear-gradient(
    100deg,
    color-mix(in srgb, var(--brand) 20%, transparent) 0%,
    transparent 70%
  );
  opacity: 0.6;
  pointer-events: none;
  transition: opacity var(--duration-base) var(--ease-default);
}

.chip:hover .wash,
.selected .wash {
  opacity: 1;
}

.selected {
  border-color: var(--border-subtle);
  background: var(--bg-elevated);
}

.selected::before {
  opacity: 1;
}

.selected:hover {
  border-color: var(--border-default);
}

/* Once a chip in the row is selected, the rest step back: desaturated and
   dimmed, so the one driving the Top 10s below is unmistakable. Hover or
   focus brings a chip back to full colour as a preview of picking it. */
:has(> .selected) > .chip:not(.selected) {
  filter: grayscale(0.85);
  opacity: 0.5;
  transition:
    transform var(--duration-fast) var(--ease-default),
    border-color var(--duration-fast) var(--ease-default),
    box-shadow var(--duration-fast) var(--ease-default),
    filter var(--duration-base) var(--ease-default),
    opacity var(--duration-base) var(--ease-default);
}

:has(> .selected) > .chip:not(.selected):hover,
:has(> .selected) > .chip:not(.selected):focus-visible {
  filter: none;
  opacity: 1;
}

@media (prefers-reduced-motion: reduce) {
  .chip {
    transition: none;
  }
}

.logo {
  position: relative;
  flex-shrink: 0;
  border-radius: var(--radius-sm);
  object-fit: contain;
}

.text {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.name {
  font-size: var(--text-base);
  font-weight: var(--weight-semi);
  color: var(--text-primary);
  line-height: 1.2;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.metric {
  display: flex;
  align-items: baseline;
  gap: var(--space-2);
  flex-wrap: wrap;
  min-width: 0;
}

.subs {
  font-family: var(--font-display);
  font-size: var(--text-lg);
  font-weight: var(--weight-bold);
  color: var(--text-primary);
  line-height: 1;
  font-variant-numeric: tabular-nums;
}

.subsLabel {
  font-size: var(--text-sm);
  color: var(--text-muted);
}
